// extracted by mini-css-extract-plugin
export var actions = "_2m-0";
export var actionsContainer = "_2m-7";
export var border = "_2m-1";
export var childFullHeight = "_2m-f";
export var collapse = "_2m-2";
export var content = "_2m-a";
export var contentChild = "_2m-e";
export var fullscreen = "_2m-c";
export var hasLeftRadius = "_2m-k";
export var headerContainer = "_2m-3";
export var headerRow = "_2m-5";
export var hidePadding = "_2m-b";
export var navCollapsedGap = "_2m-l";
export var noScrollX = "_2m-m";
export var noScrollY = "_2m-n";
export var noTopPadding = "_2m-i";
export var optOutTopPadding = "_2m-d";
export var pageMain = "_2m-j";
export var pageOuter = "_2m-g";
export var pagePadding = "_2m-8";
export var pageScroll = "_2m-9";
export var profile = "_2m-o";
export var profileContainer = "_2m-p";
export var profileImage = "_2m-q";
export var profileMain = "_2m-r";
export var profileSubtitle = "_2m-t";
export var profileTitle = "_2m-s";
export var showLeftPadding = "_2m-h";
export var tabsPortalSlot = "_2m-6";
export var tabsWrapper = "_2m-4";
export var title = "_2m-u";